// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-spinner_ldsSpinner__dNvhb {
    color: official;
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.styles-spinner_ldsSpinner__dNvhb div {
    transform-origin: 40px 40px;
    animation: styles-spinner_lds-spinner__yld8Y 1.2s linear infinite;
}
.styles-spinner_ldsSpinner__dNvhb div:after {
    content: ' ';
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: var(--primary-color);
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}
.styles-spinner_ldsSpinner__dNvhb div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}
@keyframes styles-spinner_lds-spinner__yld8Y {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loader/components/LoaderSpinner/styles-spinner.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,iEAA2C;AAC/C;AACA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,oBAAoB;AACxB;AACA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".ldsSpinner {\n    color: official;\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n}\n.ldsSpinner div {\n    transform-origin: 40px 40px;\n    animation: lds-spinner 1.2s linear infinite;\n}\n.ldsSpinner div:after {\n    content: ' ';\n    display: block;\n    position: absolute;\n    top: 3px;\n    left: 37px;\n    width: 6px;\n    height: 18px;\n    border-radius: 20%;\n    background: var(--primary-color);\n}\n.ldsSpinner div:nth-child(1) {\n    transform: rotate(0deg);\n    animation-delay: -1.1s;\n}\n.ldsSpinner div:nth-child(2) {\n    transform: rotate(30deg);\n    animation-delay: -1s;\n}\n.ldsSpinner div:nth-child(3) {\n    transform: rotate(60deg);\n    animation-delay: -0.9s;\n}\n.ldsSpinner div:nth-child(4) {\n    transform: rotate(90deg);\n    animation-delay: -0.8s;\n}\n.ldsSpinner div:nth-child(5) {\n    transform: rotate(120deg);\n    animation-delay: -0.7s;\n}\n.ldsSpinner div:nth-child(6) {\n    transform: rotate(150deg);\n    animation-delay: -0.6s;\n}\n.ldsSpinner div:nth-child(7) {\n    transform: rotate(180deg);\n    animation-delay: -0.5s;\n}\n.ldsSpinner div:nth-child(8) {\n    transform: rotate(210deg);\n    animation-delay: -0.4s;\n}\n.ldsSpinner div:nth-child(9) {\n    transform: rotate(240deg);\n    animation-delay: -0.3s;\n}\n.ldsSpinner div:nth-child(10) {\n    transform: rotate(270deg);\n    animation-delay: -0.2s;\n}\n.ldsSpinner div:nth-child(11) {\n    transform: rotate(300deg);\n    animation-delay: -0.1s;\n}\n.ldsSpinner div:nth-child(12) {\n    transform: rotate(330deg);\n    animation-delay: 0s;\n}\n@keyframes lds-spinner {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ldsSpinner": `styles-spinner_ldsSpinner__dNvhb`,
	"lds-spinner": `styles-spinner_lds-spinner__yld8Y`
};
export default ___CSS_LOADER_EXPORT___;
